<template>
  <sub-request-file></sub-request-file>
</template>

<script>
import SubRequestFile from '../components/sub-requests/sub-request-file.vue';

export default { components: { SubRequestFile } };
</script>
